const OLD_FREE_PLAN_LIMIT = 15
const OLD_ESSENTIAL_PLAN_LIMIT = 50
const OLD_EDU_SMALL_PLAN_LIMIT = 25
const OLD_EDU_MEDIUM_PLAN_LIMIT = 50

const planLimit = (state) => {
  if (state.currentUser.plan === 'free' && !state.planBenefit.abTest) {
    return OLD_FREE_PLAN_LIMIT
  }
  if ((state.currentUser.plan === 'essential' || state.currentUser.plan === 'essential-yearly' || state.currentUser.plan === 'essential-yearly-07122022' || state.currentUser.plan === 'essential-yearly-eu') && !state.planBenefit.abTest) {
    return OLD_ESSENTIAL_PLAN_LIMIT
  }
  if ((state.currentUser.plan === 'edu-small-yearly' || state.currentUser.plan === 'edu-small-yearly-eu' || state.currentUser.plan === 'edu-small-yearly-07122022' || state.currentUser.plan === 'edu-small' || state.currentUser.plan === 'edu-small-eu') && !state.planBenefit.abTest) {
    return OLD_EDU_SMALL_PLAN_LIMIT
  }

  if ((state.currentUser.plan === 'edu-medium-yearly' || state.currentUser.plan === 'edu-medium-yearly-eu' || state.currentUser.plan === 'edu-medium-yearly-07122022' || state.currentUser.plan === 'edu-medium' || state.currentUser.plan === 'edu-medium-eu') && !state.planBenefit.abTest) {
    return OLD_EDU_MEDIUM_PLAN_LIMIT
  }
  return state.plan.limit
}

export default {
  planLimit,
}
